

// import React, { useState, useEffect } from "react";
// import { fetchBrands } from "../services/brandService";
// import { fetchUsers } from "../services/adminService";
// import { createCampaign } from "../services/campaignService";
// import "./CreateCampaign.css";

// const CAMPAIGN_TYPES = [
//   { id: 1, name: "Visibility Audit", icon: "🔍", desc: "Audit visual merchandise and display assets" },
//   { id: 2, name: "Retail Audit", icon: "🏪", desc: "Check stock levels, store compliance, and pricing" },
//   { id: 3, name: "Sampling", icon: "📦", desc: "Track product sample distribution and feedback" },
// ];

// function CreateCampaign({ onSuccess }) {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [brands, setBrands] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [brandDropdownOpen, setBrandDropdownOpen] = useState(false);

//   const [formData, setFormData] = useState({
//     title: "",
//     brand_ids: [],
//     campaign_type: 1,
//     job_description: "",
//     job_qty: 10,
//     min_image: 1,
//     max_image: 5,
//     pm_id: "",
//     customer_id: "",
//     vendor_assign: "0",
//     vendor_id: "",
//     status: "ACTIVE",
//   });

//   const [refFile, setRefFile] = useState(null);
//   const [jobDetailFile, setJobDetailFile] = useState(null);

//   useEffect(() => {
//     loadDependencies();
//   }, []);

//   const loadDependencies = async () => {
//     try {
//       const [brandsData, usersData] = await Promise.all([
//         fetchBrands().catch(() => []),
//         fetchUsers().catch(() => []),
//       ]);

//       setBrands(Array.isArray(brandsData) ? brandsData : []);
//       setUsers(Array.isArray(usersData) ? usersData : []);
//     } catch (err) {
//       console.error("Error loading campaign dependencies:", err);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleRefFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       setRefFile(e.target.files[0]);
//     }
//   };

//   const handleJobDetailFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       setJobDetailFile(e.target.files[0]);
//     }
//   };

//   const validateStep = (step) => {
//     setError("");
//     if (step === 1) {
//       if (!formData.title.trim()) return "Campaign Name is required.";
//       if (!formData.job_description.trim()) return "Campaign Description is required.";
//     }
//     if (step === 2) {
//       if (Number(formData.job_qty) <= 0) return "Job Quantity must be greater than 0.";
//       if (Number(formData.min_image) < 0) return "Minimum images cannot be negative.";
//       if (Number(formData.max_image) < Number(formData.min_image)) {
//         return "Maximum images must be greater than or equal to Minimum images.";
//       }
//     }
//     return null;
//   };

//   const handleNext = () => {
//     const validationErr = validateStep(currentStep);
//     if (validationErr) {
//       setError(validationErr);
//       return;
//     }
//     setCurrentStep((prev) => Math.min(prev + 1, 5));
//   };

//   const handleBack = () => {
//     setError("");
//     setCurrentStep((prev) => Math.max(prev - 1, 1));
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       await createCampaign(formData, refFile, jobDetailFile);
//       if (onSuccess) {
//         onSuccess();
//       }
//     } catch (err) {
//       console.error("Failed to create campaign:", err);
//       setError(err.message || "An error occurred while creating the campaign.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const selectedBrandNames = brands
//     .filter((b) => formData.brand_ids.includes(b.id))
//     .map((b) => b.name || b.brand_name);
//   const selectedPM = users.find((u) => String(u.id) === String(formData.pm_id));
//   const selectedType = CAMPAIGN_TYPES.find((t) => t.id === Number(formData.campaign_type));

//   return (
//     <div className="create-campaign-container">
//       <div className="campaign-wizard-header">
//         <h2>Create New Campaign</h2>
//         <p>Configure campaign execution guidelines, file references, and field parameters</p>
//       </div>

//       {error && <div className="alert-box error">{error}</div>}

//       <div className="wizard-stepper">
//         <div className={`step-item ${currentStep >= 1 ? "active" : ""}`}>1. Basic Info</div>
//         <div className={`step-item ${currentStep >= 2 ? "active" : ""}`}>2. Execution</div>
//         <div className={`step-item ${currentStep >= 3 ? "active" : ""}`}>3. Assignment</div>
//         <div className={`step-item ${currentStep >= 4 ? "active" : ""}`}>4. Documents</div>
//         <div className={`step-item ${currentStep >= 5 ? "active" : ""}`}>5. Review & Save</div>
//       </div>

//       <div className="wizard-step-content">
//         {/* STEP 1: BASIC INFORMATION */}
//         {currentStep === 1 && (
//           <div className="step-pane">
//             <div className="form-group">
//               <label>Campaign Name <span className="required">*</span></label>
//               <input
//                 type="text"
//                 name="title"
//                 value={formData.title}
//                 onChange={handleInputChange}
//                 placeholder="e.g. Summer Visibility Audit - Delhi NCR"
//               />
//             </div>

//             <div className="form-group">
//               <label>Brand</label>
//               <div className="multi-select-dropdown">
//                 <div
//                   className="multi-select-header"
//                   onClick={() => setBrandDropdownOpen(!brandDropdownOpen)}
//                 >
//                   <span>
//                     {formData.brand_ids.length > 0
//                       ? `${formData.brand_ids.length} brand(s) selected`
//                       : "-- Select Brand(s) --"}
//                   </span>
//                   <span>{brandDropdownOpen ? "▲" : "▼"}</span>
//                 </div>

//                 {brandDropdownOpen && (
//                   <div className="multi-select-options">
//                     {brands.length === 0 ? (
//                       <div className="brand-empty-message" style={{ padding: "8px 12px", color: "#64748b", fontSize: "14px" }}>
//                         No brands available. You can assign a brand later from the Campaign List.
//                       </div>
//                     ) : (
//                       brands.map((brand) => (
//                         <label key={brand.id} className="multi-select-option">
//                           <input
//                             type="checkbox"
//                             checked={formData.brand_ids.includes(brand.id)}
//                             onChange={(e) => {
//                               const brandId = brand.id;
//                               setFormData((prev) => ({
//                                 ...prev,
//                                 brand_ids: e.target.checked
//                                   ? [...prev.brand_ids, brandId]
//                                   : prev.brand_ids.filter((id) => id !== brandId),
//                               }));
//                             }}
//                           />
//                           <span>{brand.name || brand.brand_name}</span>
//                         </label>
//                       ))
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="form-group">
//               <label>Campaign Type <span className="required">*</span></label>
//               <div className="type-cards-grid">
//                 {CAMPAIGN_TYPES.map((type) => (
//                   <div
//                     key={type.id}
//                     className={`type-card ${Number(formData.campaign_type) === type.id ? "selected" : ""}`}
//                     onClick={() => setFormData({ ...formData, campaign_type: type.id })}
//                   >
//                     <span className="type-icon">{type.icon}</span>
//                     <span className="type-title">{type.name}</span>
//                     <span className="type-desc">{type.desc}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="form-group">
//               <label>Campaign Description & Instructions <span className="required">*</span></label>
//               <textarea
//                 name="job_description"
//                 rows="4"
//                 value={formData.job_description}
//                 onChange={handleInputChange}
//                 placeholder="Provide detailed instructions for field agents..."
//                 maxLength={1000}
//               />
//               <div
//                 style={{
//                   textAlign: "right",
//                   fontSize: "12px",
//                   color: "#94a3b8",
//                   marginTop: "4px",
//                 }}
//               >
//                 {formData.job_description.length}/1000
//               </div>
//             </div>
//           </div>
//         )}

//         {/* STEP 2: EXECUTION CONFIGURATION */}
//         {currentStep === 2 && (
//           <div className="step-pane">
//             <div className="form-grid-3">
//               <div className="form-group">
//                 <label>Job Quantity <span className="required">*</span></label>
//                 <input
//                   type="number"
//                   name="job_qty"
//                   value={formData.job_qty}
//                   onChange={handleInputChange}
//                   min="1"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Min Images Required <span className="required">*</span></label>
//                 <input
//                   type="number"
//                   name="min_image"
//                   value={formData.min_image}
//                   onChange={handleInputChange}
//                   min="0"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Max Images Allowed <span className="required">*</span></label>
//                 <input
//                   type="number"
//                   name="max_image"
//                   value={formData.max_image}
//                   onChange={handleInputChange}
//                   min="1"
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* STEP 3: ASSIGNMENTS */}
//         {currentStep === 3 && (
//           <div className="step-pane">
//             <div className="form-group">
//               <label>Project Manager</label>
//               <select name="pm_id" value={formData.pm_id} onChange={handleInputChange}>
//                 <option value="">-- Select Project Manager --</option>
//                 {users.map((u) => (
//                   <option key={u.id} value={u.id}>{u.name} ({u.email})</option>
//                 ))}
//               </select>
//             </div>

//             <div className="form-group">
//               <label>Vendor Assigned</label>
//               <select
//                 name="vendor_assign"
//                 value={formData.vendor_assign}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   setFormData((prev) => ({
//                     ...prev,
//                     vendor_assign: value,
//                     vendor_id: value === "0" ? "" : prev.vendor_id,
//                   }));
//                 }}
//               >
//                 <option value="0">No</option>
//                 <option value="1">Yes</option>
//               </select>
//             </div>

//             {formData.vendor_assign === "1" && (
//               <div className="form-group">
//                 <label>Select Vendor</label>
//                 <select
//                   name="vendor_id"
//                   value={formData.vendor_id}
//                   onChange={handleInputChange}
//                 >
//                   <option value="">-- Select Vendor --</option>
//                   <option value="A">Vendor A</option>
//                   <option value="B">Vendor B</option>
//                   <option value="C">Vendor C</option>
//                 </select>
//               </div>
//             )}
//           </div>
//         )}

//         {/* STEP 4: FILES & ATTACHMENTS */}
//         {currentStep === 4 && (
//           <div className="step-pane">
//             <div className="file-upload-block">
//               <label className="file-title">Reference / Guidelines Document (PDF or Image)</label>
//               <p className="file-sub">Upload audit guidelines or visual reference charts for field workers.</p>
//               <input
//                 type="file"
//                 accept=".pdf,.png,.jpg,.jpeg"
//                 onChange={handleRefFileChange}
//               />
//               {refFile && (
//                 <div className="file-selected-card">
//                   <span>📄 {refFile.name}</span>
//                   <button type="button" className="btn-remove" onClick={() => setRefFile(null)}>Remove</button>
//                 </div>
//               )}
//             </div>

//             <div className="file-upload-block">
//               <label className="file-title">Job Allocation Detail File (Excel or CSV)</label>
//               <p className="file-sub">Upload target store list or outlet assignment sheet.</p>
//               <input
//                 type="file"
//                 accept=".xlsx,.xls,.csv"
//                 onChange={handleJobDetailFileChange}
//               />
//               {jobDetailFile && (
//                 <div className="file-selected-card">
//                   <span>📊 {jobDetailFile.name}</span>
//                   <button type="button" className="btn-remove" onClick={() => setJobDetailFile(null)}>Remove</button>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* STEP 5: REVIEW & SAVE */}
//         {currentStep === 5 && (
//           <div className="step-pane">
//             <div className="summary-card">
//               <h3>Campaign Overview</h3>
//               <table className="summary-table">
//                 <tbody>
//                   <tr>
//                     <th>Campaign Name:</th>
//                     <td>{formData.title}</td>
//                   </tr>
//                   <tr>
//                     <th>Brands:</th>
//                     <td>
//                       {selectedBrandNames.length > 0
//                         ? selectedBrandNames.join(", ")
//                         : "Unassigned"}
//                     </td>
//                   </tr>
//                   <tr>
//                     <th>Campaign Type:</th>
//                     <td>{selectedType ? selectedType.name : formData.campaign_type}</td>
//                   </tr>
//                   <tr>
//                     <th>Job Quantity:</th>
//                     <td>{formData.job_qty} Jobs</td>
//                   </tr>
//                   <tr>
//                     <th>Image Limits:</th>
//                     <td>{formData.min_image} Minimum / {formData.max_image} Maximum</td>
//                   </tr>
//                   <tr>
//                     <th>Project Manager:</th>
//                     <td>{selectedPM ? selectedPM.name : formData.pm_id || "Unassigned"}</td>
//                   </tr>
//                   <tr>
//                     <th>Guidelines File:</th>
//                     <td>{refFile ? refFile.name : "None uploaded"}</td>
//                   </tr>
//                   <tr>
//                     <th>Job Details File:</th>
//                     <td>{jobDetailFile ? jobDetailFile.name : "None uploaded"}</td>
//                   </tr>
//                   <tr>
//                     <th>Initial Status:</th>
//                     <td><span className="status-badge">{formData.status}</span></td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="wizard-footer-actions">
//         {currentStep > 1 && (
//           <button type="button" className="btn-secondary" onClick={handleBack} disabled={loading}>
//             Back
//           </button>
//         )}
//         {currentStep < 5 ? (
//           <button type="button" className="btn-primary" onClick={handleNext}>
//             Next Step →
//           </button>
//         ) : (
//           <button type="button" className="btn-success" onClick={handleSubmit} disabled={loading}>
//             {loading ? "Creating Campaign..." : "Create Campaign"}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

// export default CreateCampaign;

import React, { useState, useEffect } from "react";
import { fetchBrands } from "../services/brandService";
import { fetchUsers } from "../services/adminService";
import { createCampaign } from "../services/campaignService";
import "./CreateCampaign.css";

const CAMPAIGN_TYPES = [
  { id: 1, name: "Visibility Audit", icon: "🔍", desc: "Audit visual merchandise and display assets" },
  { id: 2, name: "Retail Audit", icon: "🏪", desc: "Check stock levels, store compliance, and pricing" },
  { id: 3, name: "Sampling", icon: "📦", desc: "Track product sample distribution and feedback" },
];

function CreateCampaign({ onSuccess }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [brands, setBrands] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [brandDropdownOpen, setBrandDropdownOpen] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    brand_ids: [],
    campaign_type: 1,
    job_description: "",
    job_qty: 10,
    min_image: 1,
    max_image: 5,
    pm_id: "",
    customer_id: "",
    vendor_assign: "0",
    vendor_id: "",
    status: "ACTIVE",
  });

  const [refFile, setRefFile] = useState(null);
  const [jobDetailFile, setJobDetailFile] = useState(null);

  useEffect(() => {
    loadDependencies();
  }, []);

  const loadDependencies = async () => {
    try {
      const [brandsData, usersData] = await Promise.all([
        fetchBrands().catch(() => []),
        fetchUsers().catch(() => []),
      ]);

      setBrands(Array.isArray(brandsData) ? brandsData : []);
      setUsers(Array.isArray(usersData) ? usersData : []);
    } catch (err) {
      console.error("Error loading campaign dependencies:", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRefFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setRefFile(e.target.files[0]);
    }
  };

  const handleJobDetailFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setJobDetailFile(e.target.files[0]);
    }
  };

  const validateStep = (step) => {
    setError("");
    if (step === 1) {
      if (!formData.title.trim()) return "Campaign Name is required.";
      if (!formData.job_description.trim()) return "Campaign Description is required.";
    }
    if (step === 2) {
      if (Number(formData.job_qty) <= 0) return "Job Quantity must be greater than 0.";
      if (Number(formData.min_image) < 0) return "Minimum images cannot be negative.";
      if (Number(formData.max_image) < Number(formData.min_image)) {
        return "Maximum images must be greater than or equal to Minimum images.";
      }
    }
    return null;
  };

  const handleNext = () => {
    const validationErr = validateStep(currentStep);
    if (validationErr) {
      setError(validationErr);
      return;
    }
    setCurrentStep((prev) => Math.min(prev + 1, 5));
  };

  const handleBack = () => {
    setError("");
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    try {
      await createCampaign(formData, refFile, jobDetailFile);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error("Failed to create campaign:", err);
      setError(err.message || "An error occurred while creating the campaign.");
    } finally {
      setLoading(false);
    }
  };

  const selectedBrandNames = brands
    .filter((b) => formData.brand_ids.includes(b.id))
    .map((b) => b.name || b.brand_name);
  const selectedPM = users.find((u) => String(u.id) === String(formData.pm_id));
  const selectedType = CAMPAIGN_TYPES.find((t) => t.id === Number(formData.campaign_type));

  return (
    <div className="create-campaign-container">
      <div className="campaign-wizard-header">
        <h2>Create New Campaign</h2>
        <p>Configure campaign execution guidelines, file references, and field parameters</p>
      </div>

      {error && <div className="alert-box error">{error}</div>}

      <div className="wizard-stepper">
        <div className={`step-item ${currentStep >= 1 ? "active" : ""}`}>1. Basic Info</div>
        <div className={`step-item ${currentStep >= 2 ? "active" : ""}`}>2. Execution</div>
        <div className={`step-item ${currentStep >= 3 ? "active" : ""}`}>3. Assignment</div>
        <div className={`step-item ${currentStep >= 4 ? "active" : ""}`}>4. Documents</div>
        <div className={`step-item ${currentStep >= 5 ? "active" : ""}`}>5. Review & Save</div>
      </div>

      <div className="wizard-step-content">
        {/* STEP 1: BASIC INFORMATION */}
        {currentStep === 1 && (
          <div className="step-pane">
            <div className="form-group">
              <label>Campaign Name <span className="required">*</span></label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="e.g. Summer Visibility Audit - Delhi NCR"
              />
            </div>

            <div className="form-group">
              <label>Brand</label>
              <div className="multi-select-dropdown">
                <div
                  className="multi-select-header"
                  onClick={() => setBrandDropdownOpen(!brandDropdownOpen)}
                >
                  <span>
                    {formData.brand_ids.length > 0
                      ? `${formData.brand_ids.length} brand(s) selected`
                      : "-- Select Brand(s) --"}
                  </span>
                  <span>{brandDropdownOpen ? "▲" : "▼"}</span>
                </div>

                {brandDropdownOpen && (
                  <div className="multi-select-options">
                    {brands.length === 0 ? (
                      <div className="brand-empty-message">
                        No brands available. You can assign a brand later from the Campaign List.
                      </div>
                    ) : (
                      brands.map((brand) => (
                        <label key={brand.id} className="multi-select-option">
                          <input
                            type="checkbox"
                            checked={formData.brand_ids.includes(brand.id)}
                            onChange={(e) => {
                              const brandId = brand.id;
                              setFormData((prev) => ({
                                ...prev,
                                brand_ids: e.target.checked
                                  ? [...prev.brand_ids, brandId]
                                  : prev.brand_ids.filter((id) => id !== brandId),
                              }));
                            }}
                          />
                          <span>{brand.name || brand.brand_name}</span>
                        </label>
                      ))
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="form-group">
              <label>Campaign Type <span className="required">*</span></label>
              <div className="type-cards-grid">
                {CAMPAIGN_TYPES.map((type) => (
                  <div
                    key={type.id}
                    className={`type-card ${Number(formData.campaign_type) === type.id ? "selected" : ""}`}
                    onClick={() => setFormData({ ...formData, campaign_type: type.id })}
                  >
                    <span className="type-icon">{type.icon}</span>
                    <span className="type-title">{type.name}</span>
                    <span className="type-desc">{type.desc}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="form-group">
              <label>Campaign Description & Instructions <span className="required">*</span></label>
              <textarea
                name="job_description"
                rows="4"
                value={formData.job_description}
                onChange={handleInputChange}
                placeholder="Provide detailed instructions for field agents..."
                maxLength={1000}
              />
              <div className="char-counter">
                {formData.job_description.length}/1000
              </div>
            </div>
          </div>
        )}

        {/* STEP 2: EXECUTION CONFIGURATION */}
        {currentStep === 2 && (
          <div className="step-pane">
            <div className="form-grid-3">
              <div className="form-group">
                <label>Job Quantity <span className="required">*</span></label>
                <input
                  type="number"
                  name="job_qty"
                  value={formData.job_qty}
                  onChange={handleInputChange}
                  min="1"
                />
              </div>

              <div className="form-group">
                <label>Min Images Required <span className="required">*</span></label>
                <input
                  type="number"
                  name="min_image"
                  value={formData.min_image}
                  onChange={handleInputChange}
                  min="0"
                />
              </div>

              <div className="form-group">
                <label>Max Images Allowed <span className="required">*</span></label>
                <input
                  type="number"
                  name="max_image"
                  value={formData.max_image}
                  onChange={handleInputChange}
                  min="1"
                />
              </div>
            </div>
          </div>
        )}

        {/* STEP 3: ASSIGNMENTS */}
        {currentStep === 3 && (
          <div className="step-pane">
            <div className="form-group">
              <label>Project Manager</label>
              <select name="pm_id" value={formData.pm_id} onChange={handleInputChange}>
                <option value="">-- Select Project Manager --</option>
                {users.map((u) => (
                  <option key={u.id} value={u.id}>{u.name} ({u.email})</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Vendor Assigned</label>
              <select
                name="vendor_assign"
                value={formData.vendor_assign}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData((prev) => ({
                    ...prev,
                    vendor_assign: value,
                    vendor_id: value === "0" ? "" : prev.vendor_id,
                  }));
                }}
              >
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>

            {formData.vendor_assign === "1" && (
              <div className="form-group">
                <label>Select Vendor</label>
                <select
                  name="vendor_id"
                  value={formData.vendor_id}
                  onChange={handleInputChange}
                >
                  <option value="">-- Select Vendor --</option>
                  <option value="A">Vendor A</option>
                  <option value="B">Vendor B</option>
                  <option value="C">Vendor C</option>
                </select>
              </div>
            )}
          </div>
        )}

        {/* STEP 4: FILES & ATTACHMENTS */}
        {currentStep === 4 && (
          <div className="step-pane">
            <div className="file-upload-block">
              <label className="file-title">Reference / Guidelines Document (PDF or Image)</label>
              <p className="file-sub">Upload audit guidelines or visual reference charts for field workers.</p>
              <input
                type="file"
                accept=".pdf,.png,.jpg,.jpeg"
                onChange={handleRefFileChange}
              />
              {refFile && (
                <div className="file-selected-card">
                  <span>📄 {refFile.name}</span>
                  <button type="button" className="btn-remove" onClick={() => setRefFile(null)}>Remove</button>
                </div>
              )}
            </div>

            <div className="file-upload-block">
              <label className="file-title">Job Allocation Detail File (Excel or CSV)</label>
              <p className="file-sub">Upload target store list or outlet assignment sheet.</p>
              <input
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={handleJobDetailFileChange}
              />
              {jobDetailFile && (
                <div className="file-selected-card">
                  <span>📊 {jobDetailFile.name}</span>
                  <button type="button" className="btn-remove" onClick={() => setJobDetailFile(null)}>Remove</button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* STEP 5: REVIEW & SAVE */}
        {currentStep === 5 && (
          <div className="step-pane">
            <div className="summary-card">
              <h3>Campaign Overview</h3>
              <table className="summary-table">
                <tbody>
                  <tr>
                    <th>Campaign Name:</th>
                    <td>{formData.title}</td>
                  </tr>
                  <tr>
                    <th>Brands:</th>
                    <td>
                      {selectedBrandNames.length > 0
                        ? selectedBrandNames.join(", ")
                        : "Unassigned"}
                    </td>
                  </tr>
                  <tr>
                    <th>Campaign Type:</th>
                    <td>{selectedType ? selectedType.name : formData.campaign_type}</td>
                  </tr>
                  <tr>
                    <th>Job Quantity:</th>
                    <td>{formData.job_qty} Jobs</td>
                  </tr>
                  <tr>
                    <th>Image Limits:</th>
                    <td>{formData.min_image} Minimum / {formData.max_image} Maximum</td>
                  </tr>
                  <tr>
                    <th>Project Manager:</th>
                    <td>{selectedPM ? selectedPM.name : formData.pm_id || "Unassigned"}</td>
                  </tr>
                  <tr>
                    <th>Guidelines File:</th>
                    <td>{refFile ? refFile.name : "None uploaded"}</td>
                  </tr>
                  <tr>
                    <th>Job Details File:</th>
                    <td>{jobDetailFile ? jobDetailFile.name : "None uploaded"}</td>
                  </tr>
                  <tr>
                    <th>Initial Status:</th>
                    <td><span className="status-badge">{formData.status}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <div className="wizard-footer-actions">
        {currentStep > 1 && (
          <button type="button" className="btn-secondary" onClick={handleBack} disabled={loading}>
            Back
          </button>
        )}
        {currentStep < 5 ? (
          <button type="button" className="btn-primary" onClick={handleNext}>
            Next Step →
          </button>
        ) : (
          <button type="button" className="btn-success" onClick={handleSubmit} disabled={loading}>
            {loading ? "Creating Campaign..." : "Create Campaign"}
          </button>
        )}
      </div>
    </div>
  );
}

export default CreateCampaign;